module.exports = __webpack_public_path__ + "static/media/bg-team-up.4cbb9c84.webp";